import { memo } from 'react';
import { Box, Text, Image } from '@betty/moonlight';
import { JackpotPlayerStatus } from '../../state/communityJackpot.types';
import { CommunityJackpotPlayerProps } from './CommunityJackpotPlayer.types';

function CommunityJackpotPlayer({
  name,
  status,
  size = 'small',
  ...rest
}: CommunityJackpotPlayerProps) {
  return (
    <Box flexDirection="row" {...rest}>
      {status && (
        <Image
          name={`communityJackpot.${status.toLowerCase() as Lowercase<JackpotPlayerStatus>}`}
          width={size === 'small' ? 'space-400' : 'space-600'}
          height={size === 'small' ? 'space-400' : 'space-600'}
          marginRight={size === 'small' ? 'space-100' : 'space-200'}
        />
      )}
      <Text
        variant={size === 'small' ? 'body-s' : 'h6'}
        color="darkSurfacePrimary"
      >
        {name}
      </Text>
    </Box>
  );
}

export default memo(CommunityJackpotPlayer);
